(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');

    // controller for tasks info
    module.controller('CreateViewModalController', ['$uibModalInstance', 'agendaCaption',  CreateViewModalController]);

    function CreateViewModalController($uibModalInstance, agendaCaption) {
        var vm = this;
 
        vm.agendaCaption = agendaCaption;

        // cancel
        vm.no = function () {
            $uibModalInstance.dismiss();  
        };

        // ok
        vm.yes = function () {
            $uibModalInstance.close();
        };      
    }
})();